import React from 'react';
import Card from '@Components/Card/Card';
import useTranslate from '@Utils/hooks/useTranslate';
import { OutletLocalisationWrapper } from './../ShippingMethod.styled';
import PageContent from './PageContent';

const OutletLocalisation = (): JSX.Element => {
	const { translate } = useTranslate();

	return (
		<OutletLocalisationWrapper>
			<PageContent
				title={translate('shipping-method.outlet.label-1')}
				description={translate('shipping-method.outlet.label-2')}
				name="locationBuild"
			>
				<Card card="outletPickup" />
			</PageContent>
		</OutletLocalisationWrapper>
	);
};

export default OutletLocalisation;
